<script setup lang="ts">
import { useAppStore } from '@/stores/app.store'
import type { Menubar, Page } from '@/types/model'
import { computed, ref } from 'vue'
import SkeletonBase from '@/components/skeleton/SkeletonBase.vue'
import NavbarMenubarItem from '@/components/navbar/NavbarMenubarItem.vue'

const appStore = useAppStore()
const menubar = computed(() => appStore.menubar as Menubar[] | undefined)
const loaded = computed(() => !!menubar.value)
const expandMenu = ref(false)

const moreMenubarItem = {
  id: 99999, // paling terakhir
  name: '',
  order: null,
  icon_only: 1,
  icon: 'more',
  page_items: [],
} as Page

const sortedMenubar = computed(() => {
  if (!menubar.value) return []

  return [...menubar.value].sort((a, b) => {
    const orderA = a.pages.order
    const orderB = b.pages.order

    if (orderA === null && orderB === null) {
      return a.pages.id - b.pages.id
    }
    if (orderA === null) return 1
    if (orderB === null) return -1

    // Jika order tidak null, urutkan berdasarkan order dulu
    if (orderA !== orderB) return orderA - orderB

    // Jika order sama, fallback ke id
    return a.pages.id - b.pages.id
  })
})
</script>

<template>
  <div v-if="loaded" class="flex">
    <div
      :class="expandMenu ? 'flex-wrap' : 'flex-nowrap overflow-hidden'"
      class="flex gap-0.5 w-full transition-all duration-150"
    >
      <navbar-menubar-item
        v-for="(page, index) in sortedMenubar"
        :key="index"
        :data="page.pages"
      ></navbar-menubar-item>
    </div>
    <div @click="expandMenu = !expandMenu">
      <navbar-menubar-item :data="moreMenubarItem"></navbar-menubar-item>
    </div>
  </div>
  <div v-else class="flex gap-2 w-full overflow-hidden">
    <skeleton-base
      v-for="n in 12"
      :key="n"
      width="1/12"
      height="9"
      rounded="xl"
      color="stone"
      custom-class="min-w-20"
    ></skeleton-base>
  </div>
</template>

<style scoped></style>
